import React, { useContext, useEffect, useState } from 'react';
import { ArrowLink, ManagedFlexModal } from '@riac/design-system';
import { Spinner } from '@riac/design-system';
import { AddressBlock } from 'src/pages/AccountPage/components/AddressBlock/AddressBlock';
import { AddressForm } from 'src/pages/AccountPage/components/AddressForm/AddressForm';
import { AddressBookContainer } from 'src/pages/AccountPage/AddressBook/AddressBook.style';
import { useFetch } from 'src/lib/FetchContext';
import { AccountPagesContext } from 'src/lib/AccountPagesContext';
import { IAddress, IAddressType, TFormAction } from 'src/pages/AccountPage/AddressBook/AddressBook.i';

export const blankAddressForm: IAddress = {
  AddressType: '',
  AddressTypeID: 10,
  CountryID: 236,
  State: '',
  AddressID: null,
  Address: '',
  Address2: '',
  City: '',
  Zip: '',
  Province: '',
};

const AddressBook = () => {
  const { fetch } = useFetch();
  const [addressTypes, setAddressTypes] = useState<IAddressType[]>([]);
  const { getAccount, getAddresses, addresses, account, getStates, getCountries } = useContext(AccountPagesContext);
  const [loading, setLoading] = useState(false);
  const [formAction, setFormAction] = useState<TFormAction>(null);
  const [addressForm, setAddressForm] = useState(blankAddressForm);

  useEffect( () => {
    getAccount();
    getStates();
    getCountries();

    async function getAddressPageData() {
      setLoading(true);
      const addressTypesReq = await fetch('/api/account/address/addressTypeList', { credentials: 'include' });
      const addressTypesRes = await addressTypesReq.json();
      setAddressTypes(addressTypesRes);
      setLoading(false);
    }
    getAddressPageData();
    getAddresses();
  }, []);

  function handleAdd() {
    setFormAction('create');
    setAddressForm(blankAddressForm);
  }

  return (
    <AddressBookContainer>
      <h1>Address Book</h1>
      <Spinner loading={loading || !account}>
        {addresses?.map((addr) =>
          <AddressBlock
            key={addr.AddressID}
            addr={addr}
            formId={addressForm.AddressID}
            formAction={formAction}
            setFormAction={setFormAction}
            blankForm={blankAddressForm}
            setForm={setAddressForm}
            addressTypeList={addressTypes}
          />
        )}
        <br/>
        {(formAction !== 'edit' && formAction !== 'create')
            && <ArrowLink onPress={() => handleAdd()}>Add a new address</ArrowLink>
        }
        <ManagedFlexModal
          isOpen = {(formAction === 'edit' || formAction === 'create')}
          title = {formAction === 'create' ? 'Create New Address' : 'Edit Address'}
          onClose = {() => setFormAction(null)}
          showCloseButton
          isDismissable
        >
          <AddressForm
            formData={addressForm}
            addressTypeList={addressTypes}
            setFormAction={setFormAction}
            formAction={formAction}
          />
        </ManagedFlexModal>
      </Spinner>
    </AddressBookContainer>
  );
};

export default AddressBook;
